export const userObjectName = 'user__s';
export const departmentObjectName = 'department__s';
